import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";

export function getAuthMenu(data) {
  return request({
    url: "apis/demo/app/getAuthMenu",
    method: "post",
    data
  });
}

export function getDetail(data) {
  return request({
    url: addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/getDetail",
    method: "post",
    data
  });
}

export function getLogin(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/users/signup/getLogin",
    method: "post",
    data
  });
}

export function getAppToken(data) {
  return request({
    url: "/apis/demo/oauth2/codeRedirect",
    method: "post",
    data
  });
}

export function getUserInfo(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/getUserInfo",
    method: "post",
    data
  });
}

export function login(data) {
  return request({
    url: "/apis/jrw/users/signup/jjt/login",
    method: "post",
    data
  });
}

export function loginForBoard(data) {
  return request({
    url: "/apis/jrw/users/signup/jjt/authorized/login",
    method: "post",
    data
  });
}
